import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const http = axios.create({ baseURL: API });

export const CHARLIE = {
  teal: "https://customer-assets-jt897jd0.emergentagent.net/job_1a124864-995c-400b-ba09-67c4486545fa/artifacts/jvns3wo9_Charlie%20teal%20background%20sketch.jpeg",
  sketches: "https://customer-assets-jt897jd0.emergentagent.net/job_1a124864-995c-400b-ba09-67c4486545fa/artifacts/dlxypc8s_Charlie%20Sketches%20lots%20combined.jpeg",
  video: "https://customer-assets-cm19k8pv.emergentagent.net/job_charlie-guides/artifacts/97zrsle1_Charlie%20Owl%20Speed%20Drawing.mp4",
  parentReading: "https://images.pexels.com/photos/23224850/pexels-photo-23224850.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  openBook: "https://images.pexels.com/photos/6561652/pexels-photo-6561652.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};
